// extracted by mini-css-extract-plugin
module.exports = {"campaign":"checkout-form_campaign__EA7Si"};